import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from "./pages/Main";
import Document from "./components/Document";
import Routing from "./pages/docs/Routing";
import Optimization from "./pages/docs/Optimization";
import Overview from "./pages/docs/Overview";
import Geocoding from "./pages/docs/Geocoding";
import ChangeLog from "./pages/ChangeLog";
import Clients from "./pages/client/Clients";
import ClientRegister from "./pages/client/ClientRegister";
import Signup from "./pages/Signup";
import Verify from "./pages/Verify";
import Faq from "./pages/Faq";
import Login from "./pages/Login";
import Mypage from "./pages/Mypage";
import PrivateOutlet from "./components/PrivateOutlet";
import Layout from "./components/Layout";
import FullPage from "./components/FullPage";
import ClientAnalytics from "./pages/client/ClientAnalytics";

const docsPaths = [
  { text: "Overview", to: "/docs" },
  { text: "Routing API", to: "/docs/routing" },
  { text: "Routing Optimization API", to: "/docs/optimization" },
  { text: "Geocoding API", to: "/docs/geocoding" },
];

const clientsPath = [
  { text: "My Clients", to: "/clients" },
  { text: "Analytics", to: "/clients/analytics" },
];

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Main />} />
          <Route element={<PrivateOutlet />}>
            <Route element={<Document paths={clientsPath} />}>
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/register" element={<ClientRegister />} />
              <Route path="/clients/analytics" element={<ClientAnalytics />} />
              <Route path="/clients/edit" element={<ClientRegister />} />
            </Route>
            <Route path="/mypage" element={<Mypage />} />
          </Route>
          <Route element={<Document paths={docsPaths} />}>
            <Route path="/docs" element={<Overview />} />
            <Route path="/docs/routing" element={<Routing />} />
            <Route path="/docs/optimization" element={<Optimization />} />
            <Route path="/docs/geocoding" element={<Geocoding />} />
          </Route>
          <Route path="/changelog" element={<ChangeLog />} />
          <Route path="/faq" element={<Faq />} />
        </Route>
        <Route element={<FullPage />}>
          <Route path="/login" element={<Login />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/signup" element={<Signup />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
